export default __webpack_public_path__ + "53f578a395ec7b5d74f0f5611912e1bc.svg";